import { render, staticRenderFns } from "./cta.vue?vue&type=template&id=5016c8ce&scoped=true&"
import script from "./cta.vue?vue&type=script&lang=js&"
export * from "./cta.vue?vue&type=script&lang=js&"
import style0 from "./cta.vue?vue&type=style&index=0&id=5016c8ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5016c8ce",
  null
  
)

export default component.exports